import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ContractCheckService {
    private selectedCheckSource = new BehaviorSubject<any>(null);
    selectedCheck$ = this.selectedCheckSource.asObservable();

    private refreshListSource = new Subject<string | null>();
    /** Emits when the sidebar should refresh its prompt sets list. Carries the prompt_set_id to re-select (or null for default). */
    refreshList$ = this.refreshListSource.asObservable();

    setSelectedCheck(check: any) {
        this.selectedCheckSource.next(check);
    }

    /** Trigger the sidebar to re-fetch the prompt sets list and re-select the given prompt set. */
    triggerListRefresh(selectPromptSetId?: string | null) {
        this.refreshListSource.next(selectPromptSetId ?? null);
    }
} 